import styled from 'styled-components';
import { colors } from '@/styles';

export const TabularFilePicker = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: ${colors.primary.white};

  table {
    font-family: var(--font-family-mono);
    width: 100%;
    border-collapse: collapse;
    border: 1px solid ${colors.secondary.lightGray3};
    td {
      padding: 10px;
      border: 1px solid ${colors.secondary.lightGray3};
      white-space: nowrap;
    }

    .right {
      text-align: right;
    }
    .center {
      text-align: center;
    }
  }

  a {
    font-family: var(--font-family-inter);
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: flex-end;
  }
`;
